export const E_RentWizard_Section = {
	TARIFF_SELECTION: "TARIFF_SELECTION",
	CONTACT: "CONTACT",
	PIN_TEST: "PIN_TEST",
	PAYMENT: "PAYMENT",
};
